import styled from 'styled-components';

export interface WrapperProps {
  $sizeStyle: string;
  fill: string;
}

// Returns a wrapper for the SVG
export const IconWrapper = styled.svg<WrapperProps>`
  pointer-events: none;
  width: ${({ $sizeStyle }) => $sizeStyle};
  height: ${({ $sizeStyle }) => $sizeStyle};
  display: inline-block;
  overflow: visible;
  path {
    fill: ${({ fill }) => fill};
  }
  rect {
    fill: ${({ fill }) => fill};
    stroke: ${({ fill }) => fill};
  }
  fill: ${({ fill }) => fill};
  stroke: ${({ fill }) => fill};
`;
